export default __webpack_public_path__ + "static/media/google-icon.041eead2.svg";